<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="shop.name"></h2>
                    </div>
                </div>
                <div class="description mb-2" v-text="displayedAddress"></div>
                <div v-if="shop.mobile_no" class="description">{{ shop.mobile_no }} (Mobile)</div>
                <div v-else class="description text-muted">No mobile no. provided</div>
                <div v-if="shop.landline_no" class="description">{{ shop.landline_no }} (Landline)</div>
                <div v-else class="description text-muted">No landline no. provided</div>
                <div class="text-right">
                    <router-link :to="link" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="btn btn-sm btn-warning">
                            <i class="fa fa-eye mr-1"></i> View Details
                        </a>
                    </router-link>
                    <button @click="removeFromFavorites" class="btn btn-sm btn-danger">
                        <i class="fa fa-trash mr-1"></i> Remove
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route, destroy, resource } from "@utils/network";

export default {
    name: "FavoriteShopListItem",

    computed: {
        displayImage() {
            return this.shop.display_image || resource("images/placeholders/avatar.jpg");
        },
        displayedAddress() {
            return this.shop.address ? this.shop.address.display_name : "";
        },
    },

    data() {
        return {
            link: `/shops/${ this.shop.id }/about`,
        }
    },

    methods: {
        async removeFromFavorites() {
            if (!(await this.confirm("Are you sure you want to remove this shop from your favorites?", "")).value) {
                return;
            }
            destroy(route("customers/favorite-shops/remove"), { params: { shop_id: this.shop.id } })
                .then(response => {
                    this.promptMessage(response.data.message.message, "")
                        .then(() => this.$emit("deleted"))
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                });
        }
    },

    mixins: [mixins],
    
    props: {
        shop: [Object],
    },

    mounted() {

    }
}
</script>